export default __webpack_public_path__ + "static/media/outsourcing-icon3.7699de43.svg";